import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Gamepad2, Plus, Star } from "lucide-react";
import api, { mediaUrl } from "@/lib/api";
import PublishGameModal from "@/components/games/PublishGameModal";

const BADGE = { pending: ["Waiting approval", "bg-amber-500/15 text-amber-400"], rejected: ["Not approved", "bg-red-500/15 text-red-400"], published: ["Published", "bg-[hsl(var(--primary))]/15 text-[hsl(var(--primary))]"] };

export default function MyGames() {
  const [items, setItems] = useState(null);
  const [open, setOpen] = useState(false);
  const load = () => api.get("/gamehub/mine").then((r) => setItems(r.data.items)).catch(() => setItems([]));
  useEffect(() => { load(); }, []);

  return (
    <div className="card-surface rounded-2xl p-5 md:p-6 mb-8" data-testid="my-games">
      <div className="flex items-center justify-between gap-3 mb-4">
        <h2 className="text-lg font-bold text-white flex items-center gap-2"><Gamepad2 size={18} className="text-[hsl(var(--primary))]" /> My Published Games</h2>
        <button onClick={() => setOpen(true)} data-testid="my-games-publish" className="inline-flex items-center gap-1.5 px-4 py-2 rounded-full bg-white/10 text-white text-sm font-semibold hover:bg-white/15"><Plus size={14} /> Publish your game</button>
      </div>
      {items === null ? <div className="text-white/40 text-sm">Loading…</div> : items.length === 0 ? (
        <p className="text-sm text-white/40" data-testid="my-games-empty">You haven't published a game yet.</p>
      ) : (
        <div className="grid sm:grid-cols-2 gap-3">
          {items.map((g) => {
            const [label, cls] = BADGE[g.status] || BADGE.published;
            return (
              <Link key={g.id} to={`/games/${g.id}`} data-testid={`my-game-${g.id}`} className="flex gap-3 p-2.5 rounded-xl bg-white/[0.03] border border-white/5 hover:bg-white/5">
                <img src={mediaUrl(g.img)} alt="" className="w-20 h-14 rounded-lg object-cover shrink-0" />
                <div className="min-w-0 flex-1">
                  <div className="text-sm font-bold text-white truncate">{g.name}</div>
                  <div className="mt-1 flex items-center gap-2 flex-wrap">
                    <span className={`px-2 py-0.5 rounded text-[10px] font-bold uppercase ${cls}`} data-testid={`my-game-status-${g.id}`}>{label}</span>
                    {g.status === "published" && <span className="inline-flex items-center gap-1 text-xs text-white/60"><Star size={11} className="text-yellow-400 fill-yellow-400" /> {g.rating_count ? g.rating_avg.toFixed(1) : "–"}/10</span>}
                  </div>
                  {g.status === "rejected" && g.reject_reason && <div className="text-[11px] text-white/40 mt-1 truncate">{g.reject_reason}</div>}
                </div>
              </Link>
            );
          })}
        </div>
      )}
      <PublishGameModal open={open} onClose={() => setOpen(false)} onSubmitted={load} />
    </div>
  );
}
